import FilterAttributeMethods from '@ve/components/filters/common/filterMethods/filterAttributeMethods/FilterAttributeMethods';
import { IBeachLine } from '../types';
import dataBeachLines from './dataBeachLineAttributes';

const BeachLineAttributeMethods = new FilterAttributeMethods<IBeachLine>(dataBeachLines, 'beachLine').setFilterName('Линия пляжа');

export default BeachLineAttributeMethods;